import { supabase } from '@/lib/supabase/config';

export interface PriceInfo {
  amount: number;
  currency: string;
}

export interface PlanPricing {
  monthly: PriceInfo;
  yearly: PriceInfo;
}

export interface PricingData {
  essential: PlanPricing;
  pro: PlanPricing;
  enterprise: PlanPricing;
  client_core: PlanPricing;
  client_growth: PlanPricing;
  client_scale: PlanPricing;
  extra_seat: PlanPricing;
  extra_subproject: PlanPricing;
  extra_derivative_kpi: PlanPricing;
}

export async function getPricing(): Promise<PricingData> {
  const { data, error } = await supabase.functions.invoke('get-pricing');

  if (error) {
    throw new Error(error.message || 'Failed to fetch pricing');
  }

  return data;
}
